import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'

import Echo from 'laravel-echo'
import Pusher from 'pusher-js'


window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Content-Type'] = 'application/json';

window.Pusher = Pusher

window.Echo = new Echo({
  broadcaster: 'pusher',
  // eslint-disable-next-line no-undef
  key: process.env.MIX_PUSHER_APP_KEY,
  cluster: process.env.MIX_PUSHER_APP_CLUSTER,
  forceTLS: true,
})

createInertiaApp({
  resolve: name => require(`./Pages/${name}`),
  title: title => title ? `${title} - Multidating` : 'Multidating',
  setup({ el, App, props, plugin }) {

    createApp({ render: () => h(App, props) })
      .use(plugin)
      .mount(el)
  },
})
